export default __webpack_public_path__ + "static/media/TodoList.8cf7ede9.jpg";